export const arrivalTypes = {
    0: "no_confirmation",
    2: "arrived",
    3: "not_arrived",
}